import Vue from 'vue';

Vue.prototype.$GOOGLESTATICMAPSAPI = {
  key: 'AIzaSyBZZymPP1juNvNA7wXDiIGIC81O57zOCVo',
  url: 'https://maps.googleapis.com/maps/api/staticmap?',
};

// Some validation rules need to be applied uniformly across the app and
// are likely to change over time and as development continues.
Vue.prototype.$VALIDATION = {
  username: 'required|email',
  password: 'required|min:8',
};

const useProdApi = false; // use this to force app to use production API whist in dev.
let applicationName = '';
let baseUrl = '';
let clientId = null;
let clientSecret = '';
let showDataRandomizer = false;
let testUser = '';
let testPassword = '';
let appVersion = 'v1.23.4';

if (process.env.NODE_ENV === 'development' && !useProdApi) {
  applicationName = 'End-Customer-Web';
  baseUrl = 'http://api.endcustomer.local/';
  clientId = 1;
  clientSecret = 'Ud3RRqI7eRObZwbtJZfMSDyPaty5pd0sKLMBP5Vv';
  showDataRandomizer = true;
  testUser = 'andymerrill@ignitionnbs.co.uk';
  testPassword = 'Secret!0';
  appVersion = appVersion + ' dev';
}

if (process.env.NODE_ENV === 'uat' && !useProdApi) {
  applicationName = 'End-Customer-Web';
  baseUrl = 'https://uatapi.endcustomer.co.uk';
  clientId = 1;
  clientSecret = 'Ud3RRqI7eRObZwbtJZfMSDyPaty5pd0sKLMBP5Vv';
  showDataRandomizer = true;
  testUser = '';
  testPassword = '';
  appVersion = appVersion + ' uat';
}

if (process.env.NODE_ENV === 'production' || useProdApi) {
  applicationName = 'End Customer';
  baseUrl = 'https://api.endcustomer.co.uk';
  clientId = 1;
  clientSecret = 'Ud3RRqI7eRObZwbtJZfMSDyPaty5pd0sKLMBP5Vv';
  testUser = '';
  testPassword = '';
  appVersion = appVersion;
}

export const AxiosConfig = {
  baseURL: baseUrl,
  applicationName,
  clientId,
  clientSecret,
};

// console.log(AxiosConfig);

export const AppConfig = {
  baseUrl,
  showDataRandomizer,
  testPassword,
  testUser,
  title: 'End-Customer-Web',
  appVersion,
};

// TODO: below should be a dynamic switch based on build
// Development
// export const LaravelEchoConfig = {
//   broadcaster: 'pusher',
//   key: 'aa9618b438ca3b2df31d',
//   cluster: 'eu',
//   encrypted: true,
//   wsHost: 'localhost',
// };

// UAT/Staging
// export const LaravelEchoConfig = {
//   broadcaster: 'pusher',
//   key: '2e4c9b38d6b85a4783fd',
//   cluster: 'eu',
//   encrypted: true,
//   wsHost: 'localhost',
// };

// Production
export const LaravelEchoConfig = {
  broadcaster: 'pusher',
  key: '43c156ec4b664f4d0b75',
  cluster: 'eu',
  encrypted: true,
  wsHost: 'localhost',
};